import { render, staticRenderFns } from "./CasesSummary.vue?vue&type=template&id=00a73a3d"
import script from "./CasesSummary.vue?vue&type=script&lang=js"
export * from "./CasesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports